import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {KanbanColumn} from '../../../../../../../../desktop/src/app/modules/kanban-board/data/kanban-column';
import {User} from '../../../../../../../../core/src/lib/login/data/user';
import {ProjectStatus} from '../../../../project-misc/data/project/statuses/project-status';
import {MultiSelect} from 'primeng/multiselect';
import {DatePeriod} from '../../graphs-view/graphs-view.component';
import {ReportsService} from '../../../data/reports.service';
import moment from 'moment';
import {LocalStorage} from 'ngx-webstorage';

@Component({
  selector: 'app-project-stat-filter',
  templateUrl: './project-stat-filter.component.html',
  styleUrls: ['./project-stat-filter.component.scss']
})
export class ProjectStatFilterComponent implements OnInit {

  @Input()
  columns: KanbanColumn[];
  selectedColumns: KanbanColumn[];

  @Input()
  users: User[]
  selectedUsers: User[]

  @Input()
  statuses: ProjectStatus[]
  selectedStatuses: ProjectStatus[]

  @Input()
  installStatuses: ProjectStatus[]
  selectedInstallStatuses: ProjectStatus[]

  @Output()
  filterUpdated = new EventEmitter<any>();

  restrictedColumnsByDefault = new Set(['Lost Projects', 'Project On Hold', 'AC dev', 'COMPLETE']);

  selectedStartDate: Date;
  selectedFinishDate: Date;

  selectedDate: DatePeriod;

  dates: DatePeriod[] = this.reportsService.dates

  @LocalStorage()
  filteredStatReportUsers: number[];

  @LocalStorage()
  filteredStatReportStatuses: number[];

  @LocalStorage()
  filteredStatReportColumns: number[];

  @LocalStorage()
  filteredStatReportInstallStatuses: number[];

  @LocalStorage()
  selectedStatDateIndex: number;

  constructor(
    protected reportsService: ReportsService
  ) {
  }

  ngOnInit(): void {
    this.selectedColumns = [...this.columns]

    for (let i = this.selectedColumns.length - 1; i >= 0; i--) {
      if (this.restrictedColumnsByDefault.has(this.selectedColumns[i].name)) {
        this.selectedColumns.splice(i, 1)
      }
    }

    this.selectedUsers = [...this.users]
    this.selectedStatuses = [...this.statuses]
    this.selectedInstallStatuses = [...this.installStatuses]


    this.selectedDate = this.dates[1];


    this.selectedStartDate = moment(this.selectedDate.startDate).toDate()
    this.selectedFinishDate = moment(this.selectedDate.finishDate).toDate()

    this.getFromLocal();

    this.updateFilter()
  }

  getFromLocal() {
    if (this.selectedStatDateIndex && this.selectedStatDateIndex >= 0) {
      this.selectedDate = this.dates[this.selectedStatDateIndex]
    }

    if (!this.filteredStatReportUsers) {
      this.selectedUsers = [...this.users]
      this.filteredStatReportUsers = this.selectedUsers.map(usr => usr.id)
    } else {
      const uIds = this.users.map(user => user.id)
      const fUIds = this.filteredStatReportUsers;
      const usersMap = new Map(this.users.map(usr => [usr.id, usr]));

      const selectedUsersIds = uIds.filter(x => !fUIds.includes(x));
      this.selectedUsers = selectedUsersIds.map(id => usersMap.get(id));
    }

    if (!this.filteredStatReportStatuses) {
      this.selectedStatuses = [...this.statuses]
      this.filteredStatReportStatuses = this.selectedStatuses.map(stat => stat.id)
    } else {
      const sIds = this.statuses.map(stat => stat.id)
      const fUIds = this.filteredStatReportStatuses;
      const statMap = new Map(this.statuses.map(stat => [stat.id, stat]));

      const selectedStatusesIds = sIds.filter(x => !fUIds.includes(x));
      this.selectedStatuses = selectedStatusesIds.map(id => statMap.get(id));
    }

    if (!this.filteredStatReportInstallStatuses) {
      this.selectedInstallStatuses = [...this.installStatuses]
      this.filteredStatReportInstallStatuses = this.selectedInstallStatuses.map(stat => stat.id)
    } else {
      const sIds = this.installStatuses.map(stat => stat.id)
      const fUIds = this.filteredStatReportInstallStatuses;
      const statMap = new Map(this.installStatuses.map(stat => [stat.id, stat]));

      const selectedStatusesIds = sIds.filter(x => !fUIds.includes(x));
      this.selectedInstallStatuses = selectedStatusesIds.map(id => statMap.get(id));
    }

    if (!this.filteredStatReportColumns) {
      this.selectedColumns = [...this.columns]
      this.filteredStatReportColumns = this.selectedColumns.map(column => column.id)
    } else {
      const cIds = this.columns.map(column => column.id)
      const fUIds = this.filteredStatReportColumns;
      const colMap = new Map(this.columns.map(column => [column.id, column]));

      const selectedColumnsIds = cIds.filter(x => !fUIds.includes(x));
      this.selectedColumns = selectedColumnsIds.map(id => colMap.get(id));
    }
  }

  updateLocals() {
    const fIndex = this.dates.findIndex(date => date.label === this.selectedDate.label)

    if (fIndex && fIndex >= 0) {
      this.selectedStatDateIndex = fIndex;
    }


    const selectedUserds = this.selectedUsers.map(user => user.id)
    this.filteredStatReportUsers = this.users.map(user => user.id).filter(userId => !selectedUserds.includes(userId));

    const selectedColumnsIds = this.selectedColumns.map(col => col.id)
    this.filteredStatReportColumns = this.columns.map(col => col.id).filter(colId => !selectedColumnsIds.includes(colId));

    const selectedStatusesIds = this.selectedStatuses.map(stat => stat.id)
    this.filteredStatReportStatuses = this.statuses.map(stat => stat.id).filter(statId => !selectedStatusesIds.includes(statId));

    const selectedInstallStatusesIds = this.selectedInstallStatuses.map(stat => stat.id)
    this.filteredStatReportInstallStatuses = this.installStatuses.map(stat => stat.id).filter(statId => !selectedInstallStatusesIds.includes(statId));
  }

  updateFilter() {
    this.updateLocals();

    const filterObj = {
      startDate: moment(this.selectedStartDate).format('YYYY-MM-DD'),
      finishDate: moment(this.selectedFinishDate).format('YYYY-MM-DD'),
      columns: this.selectedColumns.map(col => col.id),
      users: this.selectedUsers.map(usr => usr.id),
      statuses: this.selectedStatuses.map(stat => stat.id),
      installStatuses: this.selectedInstallStatuses.map(stat => stat.id),
    }

    this.filterUpdated.emit(filterObj)
  }

  showAll(multiSelect: MultiSelect) {
    multiSelect.toggleAll({})
  }

  updateDate(event) {
    this.selectedStartDate = moment(this.selectedDate.startDate).toDate()
    this.selectedFinishDate = moment(this.selectedDate.finishDate).toDate()
    this.updateFilter()
  }

  dateChange() {
    this.selectedDate = this.dates[0]

    this.updateFilter()
  }

  blurActiveElement() {
    setTimeout(() => {
      let activeElement = document.activeElement;
      if (activeElement && activeElement instanceof HTMLElement)
        activeElement.blur()
    }, 5);
  }

  monthChange() {
    const start = moment(this.selectedStartDate).startOf('month').format('YYYY-MM-DD');
    const finish = moment(this.selectedStartDate).endOf('month').format('YYYY-MM-DD');

    this.selectedStartDate = moment(start).toDate();
    this.selectedFinishDate = moment(finish).toDate();

    this.updateFilter()
  }

  minusMonth() {
    this.selectedStartDate = moment(this.selectedStartDate).subtract(1, 'M').toDate();
    this.monthChange();
  }

  plusMonth() {
    this.selectedStartDate = moment(this.selectedStartDate).add(1, 'M').toDate();
    this.monthChange();
  }
}
